/**
 * Coll Filters V2 - AJAX filter engine (fase 1 rebuild, 2026-07)
 *
 * Werkt samen met snippets/coll-filters-v2.liquid en
 * sections/collection-main-custom.liquid.
 *
 * Gedrag:
 *  - Elke filteractie (merk-klik, voorraad-toggle, prijs, sorteren, chips,
 *    wis alles) ververst alleen het grid + de sidebar via de Section
 *    Rendering API. Geen page reloads meer.
 *  - URL wordt bijgewerkt met history.pushState; back/forward werkt.
 *  - "Alleen op voorraad" staat standaard AAN: bij een kale collectie-URL
 *    wordt het voorraadfilter eenmalig via AJAX toegepast (replaceState).
 *    Zet de bezoeker de toggle uit, dan onthouden we dat in sessionStorage
 *    en blijft hij uit voor de rest van de sessie.
 *  - qls-stock-guard-v3 pakt nieuwe kaarten automatisch op (MutationObserver),
 *    de age-gate werkt via document-delegatie; wishlist/steppers hydrateren
 *    via het bestaande 'cards:rendered' event dat wij ook dispatchen.
 *
 * Alle listeners zijn document-level delegatie zodat ze DOM-swaps overleven.
 */
(function () {
  'use strict';
  if (window.__cf2Init) return;

  var AVAIL_OFF_KEY = 'cf2AvailOff';
  var sectionId = null;
  var busy = false;

  function qsAside() { return document.querySelector('[data-cf2]'); }

  function getSectionId() {
    if (sectionId) return sectionId;
    var aside = qsAside();
    if (!aside) return null;
    var sec = aside.closest('.shopify-section');
    if (!sec || !sec.id) return null;
    sectionId = sec.id.replace(/^shopify-section-/, '');
    return sectionId;
  }

  function availParam() {
    var aside = qsAside();
    return aside ? aside.getAttribute('data-avail-param') : null;
  }

  /* Canonieke 'aan'-waarde van het voorraadfilter ('true' of '1', verschilt
     per storefront-versie). Komt uit data-avail-value op de aside. */
  function availValue() {
    var aside = qsAside();
    return (aside && aside.getAttribute('data-avail-value')) || 'true';
  }

  function isTruthyAvail(val) {
    return val === 'true' || val === '1';
  }

  function collectionUrl() {
    var aside = qsAside();
    if (aside && aside.getAttribute('data-collection-url')) {
      return aside.getAttribute('data-collection-url');
    }
    return window.location.pathname;
  }

  function optedOut() {
    try { return sessionStorage.getItem(AVAIL_OFF_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(off) {
    try {
      if (off) sessionStorage.setItem(AVAIL_OFF_KEY, '1');
      else sessionStorage.removeItem(AVAIL_OFF_KEY);
    } catch (e) { /* private mode */ }
  }

  function setLoading(on) {
    var grid = document.getElementById('products');
    if (grid) grid.classList.toggle('is-cf2-loading', !!on);
  }

  /**
   * Haal de sectie-HTML op voor `url` en swap sidebar, grid en drawer-panel.
   * opts.replace  -> replaceState i.p.v. pushState
   * opts.noHistory-> history helemaal niet aanraken (popstate)
   */
  function ajaxRender(url, opts) {
    opts = opts || {};
    var secId = getSectionId();
    var u;
    try { u = new URL(url, window.location.origin); } catch (e) { window.location.href = url; return; }
    u.hash = '';
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');

    var cleanUrl = u.pathname + (u.search || '');
    if (!secId) { window.location.href = cleanUrl; return; }
    if (busy) return;
    busy = true;
    setLoading(true);

    var fetchUrl = new URL(u.toString(), window.location.origin);
    fetchUrl.searchParams.set('section_id', secId);

    fetch(fetchUrl.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var pairs = [
          ['[data-filters-desktop]', '[data-filters-desktop]'],
          ['#products', '#products'],
          ['.coll-filters-drawer__panel', '.coll-filters-drawer__panel']
        ];
        var swapped = false;
        pairs.forEach(function (p) {
          var cur = document.querySelector(p[0]);
          var next = doc.querySelector(p[1]);
          if (cur && next) {
            cur.innerHTML = next.innerHTML;
            swapped = true;
          }
        });
        if (!swapped) { window.location.href = cleanUrl; return; }

        if (!opts.noHistory) {
          var state = { cf2: true };
          if (opts.replace) history.replaceState(state, '', cleanUrl);
          else history.pushState(state, '', cleanUrl);
        }

        bindLoadMore();
        syncToggle();
        document.dispatchEvent(new CustomEvent('cards:rendered'));
        document.dispatchEvent(new CustomEvent('cf2:updated'));

        if (opts.scrollToGrid) {
          var grid = document.getElementById('products');
          if (grid) {
            var top = grid.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      })
      .catch(function () {
        window.location.href = cleanUrl;
      })
      .finally(function () {
        busy = false;
        setLoading(false);
      });
  }

  /** Huidige URL als URL-object (zonder hash). */
  function currentUrl() {
    var u = new URL(window.location.href);
    u.hash = '';
    return u;
  }

  /**
   * Schakelaar-status = URL (toegevoegd 2026-09-09).
   * Liquid rendert de toggle op basis van filter.active_values, maar op
   * een collectie waar NIETS op voorraad is kent het voorraadfilter geen
   * 'true'-waarde: de listing filtert dan wel (0 producten) maar
   * active_values blijft leeg en de knop blijft grijs. De URL is de bron
   * van waarheid voor wat Shopify filtert; deze sync zet is-on,
   * aria-checked en href daarop na init en na elke render.
   */
  function syncToggle() {
    var p = availParam();
    if (!p) return;
    var u = currentUrl();
    var on = isTruthyAvail(u.searchParams.get(p));
    var nodes = document.querySelectorAll('[data-cf2-toggle]');
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i];
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
      var h = new URL(u.toString());
      if (on) h.searchParams.delete(p); else h.searchParams.set(p, availValue());
      h.searchParams.delete('show_all');
      h.searchParams.delete('page');
      t.setAttribute('href', h.pathname + (h.search || '') + '#products');
    }
  }

  /* ============ Load more (herbind na swaps) ============ */
  function bindLoadMore() {
    var btns = document.querySelectorAll('[data-load-more]');
    btns.forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !btn.disabled) btn.click();
          });
        }, { rootMargin: '600px 0px' });
        io.observe(btn);
        btn.__autoIo = io;
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var nextUrl = btn.getAttribute('data-next-url');
        if (!nextUrl) return;
        var gridSel = btn.getAttribute('data-grid-selector') || '.coll-products';
        var grid = document.querySelector(gridSel);
        if (!grid) return;

        btn.disabled = true;
        btn.classList.add('is-loading');
        var lbl = btn.querySelector('[data-label]');
        var origText = lbl ? lbl.textContent : '';
        if (lbl) lbl.textContent = 'Laden...';

        fetch(nextUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var srcGrid = doc.querySelector(gridSel);
            if (!srcGrid) throw new Error('no grid');
            var items = srcGrid.querySelectorAll(':scope > li');
            if (!items.length) throw new Error('no items');
            items.forEach(function (li) { grid.appendChild(li); });

            var visible = grid.querySelectorAll(':scope > li').length;
            var newBtn = doc.querySelector('[data-load-more]');
            var isLastPage = !(newBtn && newBtn.getAttribute('data-next-url'));

            var total = btn.getAttribute('data-total');
            var countEl = document.querySelector('[data-toolbar-count]');
            if (countEl && total) {
              // Op de laatste pagina tonen we het echt geladen aantal als totaal.
              // paginate.items telt verborgen deal-/hidden-producten mee die het
              // grid overslaat, waardoor "52 van 61" zou blijven staan.
              var shownTotal = isLastPage ? visible : total;
              countEl.innerHTML = '<strong>1 t/m ' + visible + '</strong> van ' + shownTotal + ' producten';
            }

            if (!isLastPage) {
              btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
              btn.disabled = false;
              btn.classList.remove('is-loading');
              if (lbl) lbl.textContent = origText;
              if (btn.__autoIo) {
                btn.__autoIo.unobserve(btn);
                setTimeout(function () { btn.__autoIo.observe(btn); }, 50);
              }
            } else {
              if (btn.__autoIo) btn.__autoIo.disconnect();
              if (btn.parentNode) btn.parentNode.removeChild(btn);
            }
            document.dispatchEvent(new CustomEvent('cards:rendered'));
          })
          .catch(function () {
            window.location.href = nextUrl.split('&section_id=')[0];
          });
      });
    });
  }

  /* ============ Drawer (mobiel) ============ */
  function getDrawer() { return document.querySelector('[data-filters-drawer]'); }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var btn = document.querySelector('[data-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
  }

  function closeDrawer(scrollAfter) {
    var drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    var btn = document.querySelector('[data-filters-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      drawer.hidden = true;
      document.documentElement.style.overflow = '';
      if (scrollAfter) {
        var grid = document.getElementById('products');
        if (grid) {
          var top = grid.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    }, 220);
  }

  /* ============ Click delegatie ============ */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;

    // Drawer open/close
    var openBtn = e.target.closest('[data-filters-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    var closeBtn = e.target.closest('[data-filters-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer(closeBtn.hasAttribute('data-cf2-apply'));
      return;
    }

    // Backdrop click (buiten panel)
    var drawer = getDrawer();
    if (drawer && !drawer.hidden && drawer.contains(e.target)) {
      var panel = drawer.querySelector('.coll-filters-drawer__panel');
      if (panel && !panel.contains(e.target)) { closeDrawer(false); return; }
    }

    // "Toon meer" binnen een filtergroep
    var moreBtn = e.target.closest('[data-filter-more]');
    if (moreBtn) {
      var body = moreBtn.parentElement;
      var extra = body ? body.querySelector('[data-filter-extra]') : null;
      if (extra) {
        var show = moreBtn.querySelector('[data-more-show]');
        var hide = moreBtn.querySelector('[data-more-hide]');
        var isHidden = extra.hasAttribute('hidden');
        if (isHidden) extra.removeAttribute('hidden');
        else extra.setAttribute('hidden', '');
        if (show) show.hidden = isHidden;
        if (hide) hide.hidden = !isHidden;
      }
      return;
    }

    // Voorraad toggle
    var toggle = e.target.closest('[data-cf2-toggle]');
    if (toggle) {
      e.preventDefault();
      var p = availParam();
      if (!p) return;
      var u = currentUrl();
      var turningOff = isTruthyAvail(u.searchParams.get(p));
      if (turningOff) {
        u.searchParams.delete(p);
        setOptOut(true);
      } else {
        u.searchParams.set(p, availValue());
        setOptOut(false);
      }
      u.searchParams.delete('show_all');
      ajaxRender(u.toString());
      return;
    }

    // Wis alles: terug naar kale collectie-URL, maar respecteer voorraad-default
    var clear = e.target.closest('[data-cf2-clear]');
    if (clear) {
      e.preventDefault();
      var cu = new URL(collectionUrl(), window.location.origin);
      var cur = currentUrl();
      if (cur.searchParams.get('sort_by')) cu.searchParams.set('sort_by', cur.searchParams.get('sort_by'));
      var ap = availParam();
      if (ap && isTruthyAvail(cur.searchParams.get(ap))) cu.searchParams.set(ap, availValue());
      ajaxRender(cu.toString());
      return;
    }

    // Filter opties + chips
    var link = e.target.closest('[data-cf2-link]');
    if (link) {
      e.preventDefault();
      ajaxRender(link.getAttribute('href'));
      return;
    }
  });

  /* ============ Prijs submit ============ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cf2-price]');
    if (!form) return;
    e.preventDefault();
    var u = currentUrl();
    var gte = form.querySelector('[name="filter.v.price.gte"]');
    var lte = form.querySelector('[name="filter.v.price.lte"]');
    u.searchParams.delete('filter.v.price.gte');
    u.searchParams.delete('filter.v.price.lte');
    if (gte && gte.value !== '' && parseFloat(gte.value) > 0) u.searchParams.set('filter.v.price.gte', gte.value);
    if (lte && lte.value !== '') u.searchParams.set('filter.v.price.lte', lte.value);
    ajaxRender(u.toString());
  });

  /* ============ Sorteren ============ */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cf2-sort]');
    if (!sel) return;
    var u = currentUrl();
    u.searchParams.set('sort_by', sel.value);
    ajaxRender(u.toString());
  });

  /* ============ Back/forward ============ */
  window.addEventListener('popstate', function () {
    if (!qsAside()) return;
    ajaxRender(window.location.href, { noHistory: true });
  });

  /* ============ Init ============ */
  function init() {
    if (window.__cf2Init) return;
    var aside = qsAside();
    if (!aside) return;
    window.__cf2Init = true;

    getSectionId();
    bindLoadMore();

    // Voorraad-default: pas availability toe op kale URL, tenzij opt-out
    var p = availParam();
    if (p) {
      var u = currentUrl();
      var legacyShowAll = u.searchParams.get('show_all') === '1';
      if (legacyShowAll) setOptOut(true);
      var curVal = u.searchParams.get(p);
      if (!u.searchParams.has(p) && !optedOut() && !legacyShowAll) {
        u.searchParams.set(p, availValue());
        ajaxRender(u.toString(), { replace: true });
      } else if (curVal && isTruthyAvail(curVal) && curVal !== availValue()) {
        // Normaliseer legacy 'true' vs canonieke '1' (of andersom), anders
        // filtert de listing wel maar toont de toggle een uit-status.
        u.searchParams.set(p, availValue());
        ajaxRender(u.toString(), { replace: true });
      }
    }
    syncToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
